/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Origin_UnavailableInputs */

const en_ledger_error_origin_unavailable = /** @type {(inputs: Ledger_Error_Origin_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The database connection is unavailable`)
};

const nl_ledger_error_origin_unavailable = /** @type {(inputs: Ledger_Error_Origin_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De databaseverbinding is niet beschikbaar`)
};

/**
* | output |
* | --- |
* | "The database connection is unavailable" |
*
* @param {Ledger_Error_Origin_UnavailableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_origin_unavailable = /** @type {((inputs?: Ledger_Error_Origin_UnavailableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Origin_UnavailableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_origin_unavailable(inputs)
	return en_ledger_error_origin_unavailable(inputs)
});